import React, {Fragment, useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import {AbroadPackageClientState, ClientType, lobyTabsEnum, PackageOrigin} from '../Models/AbroadPackageModels';
import {getEpiGeneralData} from '../../cellcomAbroadBlockSlice.js';
import {fetchPackagePopular, fetchPackagePopularMarket } from '../../Shared/abroadThunk'
import {showAppLoader, hideAppLoader} from '../../../../Shared/Loader/LoaderSlice';
import AbroadPackage from './AbroadPackage';
import ShowMorePackagesButton from './../../Packages/ShowMorePackagesButton';
import '../Sass/AbroadPackagesPopular.scss';
import {useInView} from 'react-intersection-observer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import {gaEvent} from '../../../../../utilities/analytics/tracking.js';
import constants from '../../../../../utilities/analytics/constants.js';
import { getDataFromIContentRepo } from 'app/utilities/StringHelpers/StringHelpers';

interface RequestPackagePopular {
  socIdList: string[];
  blockId: number;
  clientType: ClientType;
}

interface AbroadPackagePopularProps {
  id?: number;
  context?: IEpiserverContext;
  cellcomAbroad: AbroadPackageClientState;
  selectedFamilyReducedSoc: string;
  selfCareAbroadRegularPackages?: {socName?: string; abroadPackageClient?: {reducedSocs?: {reducedSocList?: string[]}}}[];
  fetchPackagePopular: Function;
  fetchPackagePopularMarket: Function;
  getEpiGeneralData: Function;
  showAppLoader: Function;
  hideAppLoader: Function;
  requestPackagePopular: RequestPackagePopular;
  orderEvent: Function;
  isLobby?: boolean;
  isPopularMarketOrLobby: PackageOrigin;
}

const AbroadPackagePopular = (props: AbroadPackagePopularProps) => {
  const [isIn, setIsIn] = useState(false);
  const [showMoreClicked, setShowMoreClicked] = useState(false);
  let packagesToShow = showMoreClicked ? props.cellcomAbroad?.abroadPackagesPopular : props.cellcomAbroad?.abroadPackagesPopular?.slice(0, 3);
  let aboardBlocksToShow = props.cellcomAbroad?.abroadPackagesPopularMarket;

  const pageBlockId = props.context?.getRoutedContent()?.contentLink?.id;
  const reducedSocsBlockId = getDataFromIContentRepo('linkForReducedPackages')?.id;
  const isReducedSocList = reducedSocsBlockId == pageBlockId;

  const reducedSocList = React.useMemo(() => {
    const parentSocCode = props.selectedFamilyReducedSoc?.trim();
    if (!parentSocCode || !props.selfCareAbroadRegularPackages?.length) {
      return [];
    }
    const parentPackage = props.selfCareAbroadRegularPackages.find(
      (pkg) => pkg.socName?.trim() === parentSocCode,
    );

    return  parentPackage?.abroadPackageClient?.reducedSocs?.reducedSocList ?? [];
  }, [props.selectedFamilyReducedSoc, props.selfCareAbroadRegularPackages]);


  const {ref, inView} = useInView({
    threshold: 0.8,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) setIsIn(true);
  }, [inView]);

  useEffect(() => {
    const fetchDataFromLobby = async () => {
      props.showAppLoader();
      await props.fetchPackagePopular({
        SocIdList: props.requestPackagePopular.socIdList,
        BlockId: props.requestPackagePopular.blockId,
        ClientType: props.requestPackagePopular.clientType,
      });
    if (!props.isLobby) await props.getEpiGeneralData();
    props.hideAppLoader();
    };

    const fetchDataFromMarket = async () => {
      props.showAppLoader();
       var socIdList =  props.requestPackagePopular?.socIdList;
        if (isReducedSocList) {
          socIdList =  props.requestPackagePopular?.socIdList.filter(soc => reducedSocList.includes(soc));
        }
      if (!aboardBlocksToShow || !aboardBlocksToShow?.hasOwnProperty(props.id)) {
        await props.fetchPackagePopularMarket({
          SocIdList: socIdList,
          BlockId: props.requestPackagePopular.blockId,
          ClientType: props.requestPackagePopular.clientType,
          Id: props.id,
          IsReducedSocList : isReducedSocList
        });
      }
    if (!props.isLobby) await props.getEpiGeneralData();
    props.hideAppLoader();
    };


     if (props.isPopularMarketOrLobby === PackageOrigin.POPULAR) {
        fetchDataFromLobby();
      }

     else  if (props.isPopularMarketOrLobby === PackageOrigin.POPULAR_MARKET) {
        fetchDataFromMarket();
      }
  

  }, [ props.isPopularMarketOrLobby, pageBlockId]);

  useEffect(() => {
    if (props.isLobby && props.cellcomAbroad?.activeLobbyTab === lobyTabsEnum.PRIVATE) {
      const {category, eventType, eventParams} = constants.ABROAD_LOBBY_POPULAR_ARE_SHOWN_PRIVATE;
      gaEvent(category, eventType, eventParams);
    }
    if (props.isLobby && props.cellcomAbroad?.activeLobbyTab === lobyTabsEnum.BUSINESSACCOUNT) {
      if (props.cellcomAbroad?.otpData?.validatedCostumerData?.isSeparatedSale) {
        const {category, eventType, eventParams} = constants.SEPARATED_POPULARPACKAGES_SHOW;
        gaEvent(category, eventType, eventParams);
      } else {
        const {category, eventType, eventParams} = constants.ABROAD_LOBBY_POPULAR_ARE_SHOWN_BUSINESS;
        gaEvent(category, eventType, eventParams);
      }
    }
  }, [props.cellcomAbroad?.activeLobbyTab]);

  const packageListRender = (block?) => {
    if(props.isPopularMarketOrLobby === PackageOrigin.POPULAR){
      return packagesToShow?.map((pack, index) => {
        const classItem = () => {
          if (!isMobile) {
            if (index === 0) return `mb-5 abroad-market-popular__desktop__item-one${isIn ? `--animated` : ``}`;
            else if (index === 1) return `mb-5 abroad-market-popular__desktop__item-two${isIn ? `--animated` : ``}`;
            else if (index === 2) return `mb-5 abroad-market-popular__desktop__item-three${isIn ? `--animated` : ``}`;
            else return `mb-5`;
          } else {
            return `mb-0`;
          }
        };
        return (
          <Col key={index} className={`${classItem()} ${!isMobile ? 'col-4' : ''}`}>
            <AbroadPackage
              packageData={pack}
              orderEvent={props.orderEvent}
              supportedApps={props.cellcomAbroad?.getEpiGeneralData?.supportedApps}
              context={props.context}
              isSearchOrPopular={props.isPopularMarketOrLobby}
              isPrivateOrBusiness={props.cellcomAbroad?.activeLobbyTab}
              isSeparatedSale={props.cellcomAbroad?.otpData?.validatedCostumerData?.isSeparatedSale}
            />
          </Col>
        );
      });
    } else if (props.isPopularMarketOrLobby === PackageOrigin.POPULAR_MARKET) {
      return block?.map((pack, index) => {
        const classItem = () => {
          if (!isMobile && props.cellcomAbroad?.abroadPackagesPopularMarket.length <= 3) {
            if (index === 0) return `abroad-market-popular__desktop__item-one${isIn ? `--animated` : ``}`;
            else if (index === 1) return `abroad-market-popular__desktop__item-two${isIn ? `--animated` : ``}`;
            else if (index === 2) return `abroad-market-popular__desktop__item-three${isIn ? `--animated` : ``}`;
            else return ``;
          } else {
            return ``;
          }
        };
        return (
          <Col key={pack.blockId} className={`mb-5 ${classItem()} ${!isMobile ? 'col-4' : ''}`}>
            <AbroadPackage
              packageData={pack}
              orderEvent={props.orderEvent}
              supportedApps={props.cellcomAbroad?.getEpiGeneralData?.supportedApps}
              context={props.context}
              isSearchOrPopular={props.isPopularMarketOrLobby}
              isPrivateOrBusiness={props.cellcomAbroad?.activeLobbyTab}
              isSeparatedSale={props.cellcomAbroad?.otpData?.validatedCostumerData?.isSeparatedSale}
            />
          </Col>
        );
      });
    } else return <></>;
  };

  return (
    <div ref={ref}>
      <Container className={`${!isMobile ? `pr-0 pl-0 m-auto abroad-market-popular__desktop` : ''}`}>
        <Row className={'mb-1 justify-content-center'}>
          {props.isPopularMarketOrLobby === PackageOrigin.POPULAR_MARKET
            ? packageListRender(aboardBlocksToShow ? aboardBlocksToShow[props.id] : null)
            : packageListRender()}
        </Row>
        {props.isPopularMarketOrLobby === PackageOrigin.POPULAR &&
          !showMoreClicked &&
          props.cellcomAbroad?.abroadPackagesPopular?.length > 3 && (
            <Row>
              <ShowMorePackagesButton
                onClick={() => setShowMoreClicked(true)}
                customeClass={'market-show-more'}
                title={'לחבילות חו"ל נוספות'}
              />
            </Row>
          )}
      </Container>
    </div>
  );
};

const mapStateToProps = ({cellcomAbroad, selfcarePage}: {
  cellcomAbroad: AbroadPackageClientState;
  selfcarePage: {
    selectedSubscriber?: {
      abroadPackages?: {regularPackages?: AbroadPackagePopularProps['selfCareAbroadRegularPackages']};
      selectedFamilyReducedSoc?: string;
    };
  };
}) => {
  return {
    cellcomAbroad,
    selectedFamilyReducedSoc: selfcarePage.selectedSubscriber?.selectedFamilyReducedSoc,
    selfCareAbroadRegularPackages: selfcarePage.selectedSubscriber?.abroadPackages?.regularPackages,
  };
};

export default React.memo(
  connect(mapStateToProps, {
    fetchPackagePopular,
    getEpiGeneralData,
    showAppLoader,
    hideAppLoader,
    fetchPackagePopularMarket,
  })(AbroadPackagePopular)
);
